define("ember-in-viewport/utils/can-use-dom", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  var _default = _exports.default = canUseDOM;
});